// extracted by mini-css-extract-plugin
export default {"Container":"ChargingProfileTabs_Container__FwThR","ChargePointTitle":"ChargingProfileTabs_ChargePointTitle__8C7qC"};